export default "__VITE_ASSET__6ed67b2f__"